/**
 * @flow
 * @relayHash dd9db48e7fd61e8d8a1e44f64b0af85c
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type getAppsQueryVariables = {|
  orgId?: ?string,
  propertyId?: ?string,
|};
export type getAppsQueryResponse = {|
  +apps: $ReadOnlyArray<{|
    +id: string,
    +name: string,
    +url: string,
    +authorized: boolean,
    +appOrHub: string,
    +access: ?string,
    +expiredAt: ?string,
  |}>
|};
export type getAppsQuery = {|
  variables: getAppsQueryVariables,
  response: getAppsQueryResponse,
|};
*/


/*
query getAppsQuery(
  $orgId: ID
  $propertyId: ID
) {
  apps(orgId: $orgId, propertyId: $propertyId) {
    id
    name
    url
    authorized
    appOrHub
    access
    expiredAt
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "orgId",
    "type": "ID",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "propertyId",
    "type": "ID",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "apps",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "orgId",
        "variableName": "orgId"
      },
      {
        "kind": "Variable",
        "name": "propertyId",
        "variableName": "propertyId"
      }
    ],
    "concreteType": "App",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "name",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "url",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "authorized",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "appOrHub",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "access",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "expiredAt",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "getAppsQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "getAppsQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "getAppsQuery",
    "id": null,
    "text": "query getAppsQuery(\n  $orgId: ID\n  $propertyId: ID\n) {\n  apps(orgId: $orgId, propertyId: $propertyId) {\n    id\n    name\n    url\n    authorized\n    appOrHub\n    access\n    expiredAt\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'b18a5ed7255668182ccd798feea61702';
module.exports = node;
